import { createMemo, JSX, splitProps } from 'solid-js';

import { cx } from '../utils';

function Switch(props: SwitchProps & { level?: 'primary' | 'secondary' }) {
  const [, restProps] = splitProps(props, ['onChange', 'value', 'class', 'size']);
  const isSmall = createMemo(() => props.size === 'small');
  const isSecondary = createMemo(() => props.level === 'secondary');

  return (
    <div
      {...restProps}
      data-disabled={props.disabled}
      class={cx('switch', isSmall() && 'switch-xs', isSecondary() && 'switch-secondary', props.class)}
      aria-checked={props.value || undefined}
      onClick={props.disabled ? () => {} : () => props.onChange && props.onChange(!props.value)}
    >
      <div />
    </div>
  );
}

export default Switch;

interface SwitchProps extends Omit<JSX.HTMLAttributes<HTMLDivElement>, 'onChange' | 'classname'> {
  value: boolean;
  onChange?(value: boolean): void;
  size?: 'small';
  disabled?: boolean;
}
